<template>
  <div class="px-3 mt-2 bg-white" style="min-height: calc(100vh - 75px)">
    <h3 class="text-center text-premier-blue text-uppercase font-rubik-medium pt-4 mb-4">
      Masukkan Email atau Nomor Handphone
    </h3>
    <b-form-group
      id="email-input-group"
      class="form-login-register"
      label="Email/Nomor"
      label-for="emailLogin"
    >
      <b-form-input
        id="emailLogin"
        v-model="emailOrNumber"
        aria-describedby="email-field-feedback"
        :class="{'invalid-form': messageError !== ''}"
        type="email"
        required
        autofocus
        trim
        @keyup.enter="handleSubmit"
      />
      <div
        v-if="messageError !== ''"
        tabindex="-1"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        class="d-block invalid-feedback"
      >
        {{ messageError }}
      </div>
    </b-form-group>

    <div class="button-action">
      <b-button variant="success-2" class="border-r25px px-6 mb-4" size="lg" :disabled="isLoading" @click="handleSubmit">
        Masuk
        <b-spinner v-if="isLoading" small label="Small Spinner" variant="light" class="mb-1" />
      </b-button>

      <p class="mb-2 text-premier-blue font-rubik-medium">
        Belum punya akun? Buat akun sekarang
      </p>
      <b-button variant="primary-3" class="border-r25px px-6" size="lg" @click="handleGoToRegister">
        Daftar
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    emailOrNumber: '',
    messageError: '',
    isLoading: false
  }),
  watch: {
    emailOrNumber () {
      if (this.emailOrNumber.charAt(0) === '0') {
        const code = '+62'
        const number = this.emailOrNumber.substring(1).replace(/-/g, '')
        this.emailOrNumber = code.concat(number)
      }
      if (this.emailOrNumber === '') {
        this.messageError = 'Email/Nomor tidak boleh kosong'
      } else {
        this.messageError = ''
      }
    }
  },
  methods: {
    async handleSubmit () {
      this.messageError = ''
      if (this.emailOrNumber === '') { this.messageError = 'Email/Nomor tidak boleh kosong'; return }
      this.isLoading = true

      await this.$store.dispatch('doctor/submitLogin', this.emailOrNumber)
        .then((res) => {
          if (res && res.Data) {
            this.isLoading = false
            return this.handleNext()
          }
          if (res.Status === 'Error') {
            this.isLoading = false
            this.messageError = 'User tidak ditemukan!'
          }
        })
        .catch((err) => {
          this.isLoading = false
          const errorMsg = err.response.data.Message
          if (errorMsg === 'NOT_FOUND') {
            this.messageError = 'User tidak ditemukan!'
          } else if (errorMsg === 'LIMIT_EXCEEDED') {
            this.messageError = 'Anda telah mencapai batas limit, silahkan coba beberapa saat lagi'
          } else {
            throw new Error(err)
          }
        })
    },
    handleGoToRegister () {
      this.$store.commit('doctor/SET_STEP', 'register')
      localStorage.setItem('step', 'register')
    },
    handleNext () {
      localStorage.setItem('step', 'input-otp')
      this.$store.commit('doctor/SET_STEP', 'input-otp')
    }
  }
}
</script>

<style lang="scss">
  $primary: #024668;
  .px-6 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .button-action {
    text-align: center;
    margin-top: 5rem;
  }

  #email-input-group {
    padding: 0px 23px;
  }
</style>
